// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__BgmTs","table":"style_table__GTtIn","linkable":"style_linkable__mFc7k"};